module.exports = __webpack_public_path__ + "static/media/image_86.82cc3002.png";